import { createAction, props } from '@ngrx/store';
import { asyncProps, FromApiActionPayload, WithRequestId, AsyncRequest } from '@lib/store';
import { CreateOrderModel } from './create-order.state';

/** StateDetailsActions */
const ACTION_SET = '[CreateOrder] set';
const ACTION_UPDATE = '[CreateOrder] update';
const ACTION_RESET = '[CreateOrder] reset';
const ACTION_FAIL = '[CreateOrder] fail';
const ACTION_CANCEL_REQUEST = '[CreateOrder] cancel request';

/** Async Actions */
const ACTION_SET_FROM_API = '[CreateOrder] set from api';
const ACTION_UPDATE_FROM_API = '[CreateOrder] update from api';

/**
 * Clear the current store object and replace it with the new one,
 * update isFailure to false, and update isPending with the boolean given as parameter if defined
 */
export const setCreateOrder = createAction(ACTION_SET, props<WithRequestId<CreateOrderModel>>());

/**
 * Change a part or the whole object in the store and update isFailure to false. The pendingUpdate boolean,
 * if set to true or false, will update the isPending property from the StateDetails
 */
export const updateCreateOrder = createAction(ACTION_UPDATE, props<WithRequestId<Partial<CreateOrderModel>>>());

/**
 * Clear the whole state, return to the initial one
 */
export const resetCreateOrder = createAction(ACTION_RESET);

/** Action to cancel a Request ID registered in the store. Can happen from effect based on a switchMap for instance */
export const cancelCreateOrderRequest = createAction(ACTION_CANCEL_REQUEST, props<AsyncRequest>());

/**
 * Update isPending from the StateDetails to false, and isFailure to true
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const failCreateOrder = createAction(ACTION_FAIL, props<WithRequestId<{ error: any }>>());

/**
 * Update isPending to true, triggers setFromApi Effect
 */
export const setCreateOrderFromApi = createAction(
  ACTION_SET_FROM_API,
  asyncProps<FromApiActionPayload<CreateOrderModel>>()
);

/**
 * Update isPending to true, triggers updateFromApi Effect
 */
export const updateCreateOrderFromApi = createAction(
  ACTION_UPDATE_FROM_API,
  asyncProps<FromApiActionPayload<CreateOrderModel>>()
);
